import { render, staticRenderFns } from "./ConnectorBrandIcon.vue?vue&type=template&id=31a7ab38&scoped=true"
import script from "./ConnectorBrandIcon.vue?vue&type=script&lang=js"
export * from "./ConnectorBrandIcon.vue?vue&type=script&lang=js"
import style0 from "./ConnectorBrandIcon.vue?vue&type=style&index=0&id=31a7ab38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7ab38",
  null
  
)

export default component.exports